import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerIcon} from '../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface FailedDraftBannerProps {
  onDismissClick: () => void;
  description?: string;
}

/*
 * Component.
 */

export const FailedDraftBanner: FC<FailedDraftBannerProps> = (props) => {
  const theme = useUserTheme();
  const {onDismissClick, description} = props;
  const errorDescription = description || (
    <Trans id="failed-draft-description">
      There was an error sending the message. Go to the Drafts folder for more details.
    </Trans>
  );
  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerIcon iconName="draftFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="failed-draft-title">Draft failure</Trans>
        </BannerContentTitle>
        {errorDescription}
      </BannerContent>
    </Banner>
  );
};
